export default {
  mode: "call",
  sessionId: "",
  hideNotificationLabel: "",
  roomNumber: "",
};
